/**
 * Right now these constants exist to set the design for the multislot booking page.
 * Eventually, these might become controlled via settings or changed. So for now, we simply
 * keep them here so they will be easy to update.
 */

export const TIMEBAR_WIDTH_PX = 60;
export const COLUMN_MIN_WIDTH_PX = 168;
export const AGENDA_PIXELS_PER_MINUTE = 2.4;
export const AGENDA_MINUTES_PER_SLOT = 15;
